import apiRequest, { apiUpload } from './client';

export const listCompanies = () => apiRequest('/companies/');

export const getCompany = (id) => apiRequest(`/companies/${id}/`);

export const createCompany = (data) => apiRequest('/companies/', { method: 'POST', body: data });

export const updateCompany = (id, data) =>
  apiRequest(`/companies/${id}/`, { method: 'PATCH', body: data });

// Variantes multipart — utilisees uniquement quand un logo (Blob deja recadre par
// LogoCropInput) accompagne le formulaire, cf. SuperadminCompanyFormPage.
export const createCompanyWithLogo = (formData) =>
  apiUpload('/companies/', formData, { method: 'POST' });

export const updateCompanyWithLogo = (id, formData) =>
  apiUpload(`/companies/${id}/`, formData, { method: 'PATCH' });

export const listGroups = (companyId) => apiRequest(`/bank-groups/?company=${companyId}`);

export const createGroup = (data) => apiRequest('/bank-groups/', { method: 'POST', body: data });

export const updateGroup = (id, data) =>
  apiRequest(`/bank-groups/${id}/`, { method: 'PATCH', body: data });

export const deleteGroup = (id) =>
  apiRequest(`/bank-groups/${id}/`, { method: 'DELETE' });

export const listDeviceRegistrations = (companyName = '') =>
  apiRequest(`/device-registrations/${companyName ? `?company=${encodeURIComponent(companyName)}` : ''}`);

// `username` optionnel : choisi a la main quand le username genere (serial)
// est deja pris par une autre banque (409, code 'username_collision').
export const approveDeviceRegistration = (id, username) =>
  apiRequest(`/device-registrations/${id}/approve/`, {
    method: 'POST',
    body: username ? { username } : undefined,
  });

export const rejectDeviceRegistration = (id) =>
  apiRequest(`/device-registrations/${id}/reject/`, { method: 'POST' });

// Demandes de deblocage du mode kiosque leger (lottery-app, ecran cache
// Kiosk Admin) — toutes companies confondues, filtrable par statut.
export const listKioskUnlockRequests = (statusFilter = '') =>
  apiRequest(`/kiosk-unlock-requests/${statusFilter ? `?status=${encodeURIComponent(statusFilter)}` : ''}`);

export const approveKioskUnlockRequest = (id) =>
  apiRequest(`/kiosk-unlock-requests/${id}/approve/`, { method: 'POST' });

export const rejectKioskUnlockRequest = (id) =>
  apiRequest(`/kiosk-unlock-requests/${id}/reject/`, { method: 'POST' });

// Revue des justificatifs de paiement deposes par les companies (page "Pay
// Online" -> PaymentInvoicePage.jsx) — toutes companies confondues,
// filtrable par statut. `approve` incremente invoice.amount_paid du montant
// VERIFIE (par defaut celui declare par la company, modifiable) et
// recalcule le blocage automatique de la company cote backend.
export const listPaymentSubmissions = (statusFilter = '') =>
  apiRequest(`/billing/payment-submissions-admin/${statusFilter ? `?status=${encodeURIComponent(statusFilter)}` : ''}`);

export const approvePaymentSubmission = (id, verifiedAmount) =>
  apiRequest(`/billing/payment-submissions-admin/${id}/approve/`, {
    method: 'POST', body: { verified_amount: verifiedAmount },
  });

export const rejectPaymentSubmission = (id) =>
  apiRequest(`/billing/payment-submissions-admin/${id}/reject/`, { method: 'POST' });

// Comptes staff LIMITES (auth.User is_staff=True/is_superuser=False, permissions
// par entree de menu du portail company — cf. companies.models.AdminMenuPermission).
export const getMenuCatalog = () => apiRequest('/auth/superadmin/menu-catalog/');

export const listStaffUsers = () => apiRequest('/superadmin/staff-users/');

export const createStaffUser = (data) =>
  apiRequest('/superadmin/staff-users/', { method: 'POST', body: data });

export const updateStaffUser = (id, data) =>
  apiRequest(`/superadmin/staff-users/${id}/`, { method: 'PATCH', body: data });

export const deleteStaffUser = (id) =>
  apiRequest(`/superadmin/staff-users/${id}/`, { method: 'DELETE' });

// ── Banques / POS de toutes les companies (2026-09-26) ──────────────────────
export const listAdminBanks = ({ q = '', archived = false, company } = {}) => {
  const params = new URLSearchParams();
  if (q) params.set('q', q);
  if (archived) params.set('archived', '1');
  if (company) params.set('company', company);
  return apiRequest(`/admin/banks/?${params.toString()}`);
};

export const restoreAdminBank = (id) => apiRequest(`/admin/banks/${id}/restore/`, { method: 'POST' });

// { company, group?, note?, confirm_offline_synced } -> { bank, password, transfer_id }
export const transferAdminBank = (id, data) =>
  apiRequest(`/admin/banks/${id}/transfer/`, { method: 'POST', body: data });

export const listBankTransfers = () => apiRequest('/admin/bank-transfers/');

// Effacement DEFINITIF (superadmin principal) : { confirm: "EFFACER <N°>" }
// -> { freed_seq, company_id, tickets, lines, deposits }. Copie gardee dans l'audit.
export const purgeAdminBank = (id, confirm) =>
  apiRequest(`/admin/banks/${id}/purge/`, { method: 'POST', body: { confirm } });

// Donne a une banque un N° libre de sa company (ex. celui libere par purgeAdminBank).
export const setAdminBankSeq = (id, seq) =>
  apiRequest(`/admin/banks/${id}/set-seq/`, { method: 'POST', body: { seq } });

// Recherche Ticket par serial dans toutes les companies.
// La date est optionnelle au format YYYY-MM-DD.
export const searchTicketsBySerial = ({ serial, date }) => {
  const qs = new URLSearchParams({ serial });
  if (date) qs.append('date', date);
  return apiRequest(`/admin/tickets/search/?${qs.toString()}`);
};

// Username POS (Bank.username) modifie a la main — provisoire, en cas de
// collision avec une autre banque. { reset: true } = remet le username
// automatique (derive du serial). Le mot de passe ne change pas.
export const setAdminBankUsername = (id, username) =>
  apiRequest(`/admin/banks/${id}/set-username/`, { method: 'POST', body: { username } });

export const resetAdminBankUsername = (id) =>
  apiRequest(`/admin/banks/${id}/set-username/`, { method: 'POST', body: { reset: true } });
